export enum ApiStatusCodeVo {
  EventParticipationSuccess = 309,
  NotRegularMember = 20,
  Success = 0,
  /** 서버에서 주는 메시지를 그대로 사용합니다. */
  ErrorShowServerMsg = -2,
  UnregisteredUserV2 = -50,
  InactiveAccount = -51,
  SignupFailed = -53,
  SignupTimeExpired = -54,
  NeedUpdate = -99,
  NotAuthorized = -100,
  RestrictMemberLoginGlobal = -102,
  ExpiredVerification = -110,
  VerifyCodeNotFound = -111,
  VerifyCodeGenerateFail = -112,
  VerifyCodeNotLatest = -113,
  NoExistsUserMatchedEmail = -120,
  DuplicatedAccount = -121,
  EmailOrPasswordNotMatch = -122,
  SameAsPreviousPassword = -123,
  EmailLoginBlocked = -124,
  EmailVerifyLimitExceeded = -125,
  ShowRecaptcha = -130,
  UserNotFound = -150,
  /** 탈퇴 후 7일 동안 재가입 불가합니다. */
  RejectRegisterFor7DaysAfterUnRegister = -151,
  RejectGlobalRegisterCountry = -152,
  IncorrectCountryCode = -153,
  /** 글로벌 카카오 유저가 국내 웹에서 로그인 시도  */
  FailToLoginWithIncorrectOs = -154,
  NotPurchased = -200,
  NotAvailableOnWeb = -205, // -205 에러는 api.ts의 processOnFailAsync에서 공통으로 처리하지 않고 API를 호출하는곳에서 직접 처리한다.
  ItemNotSales = -207,
  TodayGiftExpired = -210,
  TodayGiftNotTargetUser = -211,
  TodayGiftAlreadyReceived = -212,
  TodayGiftDataWriteFail = -213,
  ReceiveGiftLimitExceed = -214,
  ReceiveGiftExpired = -215,
  TicketNotEnough = -301,
  CashNotEnough = -302,
  EarlyTicketNotEnough = -303,
  /**
   * NEXT 부터는 Vod 뿐만 아니라 모든 회차에 기기제한 적용됨. 이름에서 VOD 제거할까 했으나 v1 에서 이름 그대로 사용중이라 일단 유지
   */
  VodDeviceLimitOver = -304,
  VodPingFailed = -307,
  VodDeviceChangeLimitOver = -310,
  VodNotRegisteredDevice = -312,
  VodInvalidDevice = -313,
  VodInvalidPoint = -314,
  WaitForPreviousRequest = -317,
  ItemAlreadyPurchased = -351,
  TicketInfoInvalid = -352,
  UnknownError = -500,
  NoMappingDataError = -502,

  // 빌링 서버점검
  BillingMaintenance = -516,

  CommentWriteFailBlocked = -602,
  EventDuplicationNotAllowed = -740,
  EventNotFound = -741,
  EventClosed = -742,
  EventRewardFailed = -743,
  EventPointNotExist = -744,
  KlipRequestKeyNotExist = -745,
  VodLicenseAuthorizationFalse = -780,
  VodLicenseInvalidSingleId = -781,
  VodLicenseOverRentDuration = -782,
  VodLicenseInvalidPayHistory = -783,
  VodLicenseOverMaxMultiDevice = -784,
  VodLicenseFailGetLicense = -785,
  VodLicenseRequiredPayload = -786,
  VodLicenseInvalidDrmType = -787,
  VodLicenseCummunicationFail = -788,
  VodLicenseInvalidContentPack = -789,
  VodLicenseRequiredContentPackId = -790,
  VodLicenseInvalidContents = -791,
  VodLicenseInvalidContentsDetail = -792,
  VodLicenseServerNeedUpdateProtocolVersion = -793,
  VodLicenseInvalidRequestInfo = -794,
  VodInvalidCountry = -795,
  VodInvalidProxyIpType = -796,
  VodNotExpectedError = -797,
  VodLicenseSpcDuplicationTag = -799,
  VodLicenseInvalidTagException = -800,
  VodLicenseCantFindDrmkey = -803,
  VodLicenseFailDecryptDrmkey = -804,
  VodNoRightToPlay = -805,
  VodLicenseRequiredMandatoryTag = -806,
  VodLicenseNotMatchDrmType = -807,
  VodLicenseNotMatchUserId = -808,
  VodLicenseNoSuchAlgorithm = -810,
  VodMobileOnly = -813,
  ServerMaintenance = -7504,
  AuthInfoRequestOver = -900,
  AuthInfoTimeOver = -901,
  /** 정보 입력창에서 취소 버튼 클릭 (추가 파라미터 사용시에만 적용)
   *  APP에서 취소 버튼이 있는데 APP에서 토스트 팝업으로 자체 처리중 */
  AuthInfoUserCancel = -902,
  AuthInfoDifferentPrevCi = -903,
  /** 본인인증 연령이 14세 이하. 참고로 14세 이하는 본인인증 할 수 없음.
   * 그래서 드림시큐리티에서 14세 이하인 경우 얼럿을 보여주고 있어서 페이지웹에서 처리할 필요는 없음. */
  AuthInfoUnder14 = -904,
  AuthInfoFailedThreeTimes = -905,
  /**
   * 14세 미만 유저와 보호자의 연령 차이가 18세 미만일 경우 보호자 인증 불가합니다.
   */
  AuthInfoAgeDifferenceFail = -906,
  /**
   * 14세 미만 아동 인증 정보는 있으나 보호자 인증정보가 없는 경우
   * 그래서 인증 플로우를 다시 태워야 합니다.
   */
  Under14AgeAuthCompletedWithoutLegalAgentAuth = -907,
  /**
   * 카카오뱅크 모바일 신분증 에러가 날 경우
   */
  KakaoBankSelfCertError = -910,
  /**
   * 해당 국가에서는 감상할 수 없는 작품입니다
   */
  ItemAccessRestrictionCountryDenied = -2000,
  KakaoError = -40500,
  /**
   * Redeem 관련 에러코드 (https://kakaopagecorp.slack.com/archives/C040YR56D/p1637029163330200?thread_ts=1636522660.271900&cid=C040YR56D)
   **/
  RedeemUseFail = -1100,
  RedeemInvalidForm = -1101,
  RedeemAlreadyUsed = -1102,
  RedeemExpiredCoupon = -1103,
  RedeemAlreadyReceived = -1104,
  RedeemAlreadyUsedCodeGroup = -1105,
  RedeemOnlyNewlyJoinedUser = -1106,
  RedeemOnlyReturnUser = -1107,
  RedeemOnlyNewlyJoinedUserAfter = -1108,
  RedeemOnlyNewlyJoinedUserBefore = -1109,
  RedeemProductNotOnSale = -1110,
  RedeemInvalidCoupon = -1111,
  /**
   * 공통 리딤코드 관련 에러코드
   */
  RedeemInvalidTarget = -1112,
  RedeemInvalidCodeGroup = -1113,
  RedeemFailGiveCash = -1114,
  RedeemCannotUseInSameCampaign = -1115,
  RedeemDuplicatedRedeemCodeHistoryOperation = -1116,
  RedeemInvalidSeries = -1117,
  RedeemPreparedQuantityExhausted = -1118,
  RedeemTooShortRequest = -1119,
  RedeemDuplicatedDeviceId = -1120,

  PointAge = -1210,
  /**
   * 캐시 뽑기 대상자가 아닌 유저 (KW-10349)
   * /v2/gotcha/draw API 에러코드
   */
  GotchaInvalidTarget = -1200,
  /**
   * 외부업체(쿠프, 11번가)에서 넘어오는 API 에러코드
   * key에 'External' value에 '10'을 prefix로 붙여 중복을 피함
   * 참고Url(쿠프) : https://podotree.atlassian.net/wiki/spaces/QA/pages/567837002
   * 참고Url(11번가) : https://podotree.atlassian.net/browse/KAPIS-618
   */
  ExternalUnknownError = -10500,
  ExternalNeedParameter = -10105,
  ExternalNotAuthorized = -10114,
  ExternalExceedChargeLimit = -10115,
  ExternalExceedCashLimit = -10116,
  ExternalAbnormalUser = -10117,
  ExternalExceedMinorChargeLimit = -10122,
  ExternalInvalidDataForm = -10125,
  ExternalNeedBrandCode = -10126,
  ExternalAbnormalCoupon = -10127,
  ExternalMismatchProduct = -10209,
  ExternalMismatchBrand = -10210,
  ExternalMismatchCode = -10211,
  ExternalCanceledCoupon = -10309,
  ExternalUsedCoupon = -10310,
  ExternalExpiredCoupon = -10311,
  ExternalNotExistCoupon = -10407,
  ExternalRequestEndError = -10510,
  ExternalRequestHeaderError = -10511,
  ExternalMismatchAPIVersion = -10134,
  ExternalNotUsedCoupon = -10312,
  ExternalIrrevocableCoupon = -10313,
  ExternalCouponCancelFailed = -10513,
  /**
   * 통합선물함 선물 지급 요청 API 에러코드
   * 참고 Url : https://podotree.atlassian.net/wiki/spaces/PSD/pages/2751202202
   */
  SpecialGiftFailed = -240,
  SpecialGiftOverlap = -241,
  SpecialGiftNotTarget = -242,
  SpecialGiftNotFound = -243,
  /**
   * 헬릭스 랜딩페이지 작품 목록 조회 API 에러코드
   * 참고 Url: https://wiki.daumkakao.com/pages/viewpage.action?pageId=1269261012
   */
  HelixLandingEmptySeriesList = -1308,
  HelixLandingEmptyExpireDate = -1309,
  /**
   * 세트 상품 정보 API 에러코드
   */
  /**
   * 판매중이 아닌 세트상품입니다.
   */
  SetNotOnSale = -1600,
  /**
   * 세트의 모든 회차를 소장 중입니다.
   */
  SetAllOwned = -1601,
  /**
   * 이미 구매한 상품입니다.
   */
  SetAlreadyPurchased = -1602,
  /**
   * global 로그인(SNS, Email)에서 사용하는 에러코드
   */
  InvalidEmailAccountOrPassword = -122,
  BannedUser = -102,
  /**
   * global 보호자 이메일 인증 결과에서 사용하는 에러코드
   */
  ParentVerificationExpired = -110,
  ParentVerificationInvalidCode = -111,
  ParentVerificationInvalidEmail = -113,
  /**
   * 새로고침이 필요한 경우에 사용하는 에러코드
   * (예시. 버전 불일치 혹은 캐싱된 데이터라서 최신 버전과 불일치하는 경우)
   */
  RefreshRequired = -2802,
}
